<template>
    <div>
        <p v-if="glsPoint"><span id="gls-ajax-result" v-html="glsPoint.pclshopid"></span></p>

        <span id="gls-method-label" ></span>
        {{ __('Írj be egy várost, utcanevet vagy irányítószámot!') }}

        <div class="my-margin-left-20" id="gls-map" style="border: 1px; position: relative" >
            <div id="big-canvas"></div>
        </div>
        <form-error
            v-if="errors && Object.keys(errors).length > 0"
            field="pickup_point_id"
            :errors="errors"
        />
    </div>
</template>

<script>
export default {
    name: 'GlsPickupPoints',

    props: {
        pickupPoint: {
            default: null
        },
        showParcelShops: {
            default: 1
        },
        showParcelLockers: {
            default: 0
        }
    },

    data() {
        return {
            glsPoint: null,
            errors: null,
        }
    },

    mounted() {
        let glsMap = window.glsMap

        glsMap.init(window.countryCode, 'big-canvas', window.city, 1, null, this.showParcelShops, this.showParcelLockers, null);
        google.maps.event.trigger(glsMap, 'resize');

        window.app.$on('selected-gls-point', glsPoint => this.glsPoint = glsPoint)
    },

    watch: {
        glsPoint() {
            this.$emit('input', this.glsPoint)
        }
    },

    methods: {
        glsPSMap_OnSelected_Handler(data) {
            var glsPoint = null

            if (data.hasOwnProperty('pclshopid') && data.pclshopid) {
                glsPoint = data;
                $('#gls-ajax-result').html(glsPoint.pclshopid);
            } else {
                glsPoint = null;
                $('#gls-ajax-result').html('');
            }
        },
    },
}
</script>

<style scoped>
#big-canvas {
    margin-top: 30px;
    margin-bottom: 30px;
    width: 600px;
    height: 400px;
}

#ajaxresult {
    position: absolute;
    left: 0px;
    top: 0px;
}
</style>
